import React from 'react';
import { bool, func } from 'prop-types';
import { Field, Form, reduxForm } from 'redux-form';
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import FieldWrapper from 'components/common/FieldWrapper';
import { alternateSecondPageValidations } from './validations';

export function AlternateSecondPage({
  handleSubmit,
  previousPage,
  submitting
}) {
  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <h2 id="partner-contact-form-heading">
            Affiliate/Publisher Interest Questionnaire
            <small className="smaller block">
              Please provide any additional information that you think would
              help us better understand what you do, how you do it, and how you
              think we can potentially work together.
            </small>
          </h2>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col xs={12}>
          <Field
            autofocus
            component={FieldWrapper}
            inputComponent="textarea"
            inputComponentProps={{
              autoFocus: true,
              className: 'form-control',
              rows: 12,
              tabIndex: '1'
            }}
            label="Additional Information"
            name="additional_information"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="margin-bottomgap20 text-center">
          <ButtonGroup className="pull-right">
            {/* eslint-disable jsx-a11y/tabindex-no-positive */}
            <Button bsStyle="warning" onClick={previousPage} tabIndex="2">
              <FontAwesome name="chevron-left" tag="i" />
              {' Back'}
            </Button>
            <Button
              bsStyle="success"
              disabled={submitting}
              tabIndex="3"
              type="submit"
            >
              {/* eslint-enble jsx-a11y/tabindex-no-positive */}
              <FontAwesome name="paper-plane" tag="i" />
              {' Submit'}
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </Form>
  );
}

AlternateSecondPage.propTypes = {
  handleSubmit: func.isRequired,
  previousPage: func.isRequired,
  submitting: bool.isRequired
};

export default reduxForm({
  form: 'partnerSubmissionForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: alternateSecondPageValidations
})(AlternateSecondPage);
